// TODO: replace with the date from the server when it is ready on the backend
export const mergeCommentWithUserData = (
  { data: { id, ...backendComment } },
  { data: userData },
) => ({
  ...backendComment,
  commentId: id,
  bountyPurse: [],
  visibleTo: [backendComment.metadata.createdBy],
  lockedCoins: 0,
  unlockPrice: 0,
  userdata: {
    ...userData,
    tags: [],
  },
});

export const mergeCommentListWithUserData = (
  { data: commentsList },
  { data: userDataMap },
) => ({
  comments: commentsList.map(comment =>
    mergeCommentWithUserData(
      { data: comment },
      {
        data: userDataMap[comment.id],
      },
    ),
  ),
});
